import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useFilesUploadStore } from 'src/common/store/files-upload.store';
import useDashboardStore from 'src/dashboard/store/dashboard';
import { useUserOnboardingStore } from 'src/onboarding/store/user-onboarding.store';
import { WizardArtBoard } from '../art-board';
import { WizardModal, WizardModalProps } from '../modal';
import { useWizardStore } from '../store';
import { WizardLoadingProgressBar } from './progress-bar';

const CLOSE_TIMEOUT_DURATION = 2500;

export const WizardLoadingScreen = ({ openRef, closeRef }: WizardModalProps) => {
  const history = useHistory();
  const setUploadingBubbleShow = useUserOnboardingStore((state) => state.setShow);
  const { resetWizardStore, journeyUUID, isWizardCompleted } = useWizardStore((state) => ({
    journeyUUID: state.journey?.uuid,
    resetWizardStore: state.resetStore,
    isWizardCompleted: state.isWizardCompleted,
  }));
  const setIsCreatingJourney = useDashboardStore((state) => state.setIsCreatingJourney);
  const resetFilesUploadStore = useFilesUploadStore((state) => state.resetStore);

  const finalizeLoadingScreen = () =>
    setTimeout(() => {
      resetFilesUploadStore();
      history.replace(`/journeys/edit/${journeyUUID}`);
      closeRef.current();
      resetWizardStore();
      setIsCreatingJourney(false);
    }, CLOSE_TIMEOUT_DURATION);

  useEffect(() => {
    let closeScreenTimeoutId: ReturnType<typeof setTimeout>;
    if (isWizardCompleted) {
      closeScreenTimeoutId = finalizeLoadingScreen();
    }

    return () => {
      clearTimeout(closeScreenTimeoutId);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWizardCompleted, journeyUUID]);

  return (
    <WizardModal
      hideCloseButton
      openRef={openRef}
      closeRef={closeRef}
      onOpen={() => {
        setUploadingBubbleShow(false);
      }}
    >
      <WizardLoadingProgressBar />
      <div className='flex w-full md:w-[calc(100%-352px)] h-full items-center mx-10 md:ml-20'>
        <div className='max-w-[624px]'>
          <h1 className='text-bedrock-h1 font-brand-serif text-bedrock-black'>
            Our wizards, Elzabor and Sable, have started stitching your Journey together
          </h1>
        </div>
      </div>
      <WizardArtBoard />
    </WizardModal>
  );
};
